import { render } from "./TheInputText.vue?vue&type=template&id=60a3eaea"
import script from "./TheInputText.vue?vue&type=script&lang=js"
export * from "./TheInputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__